
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/watches/all",
      function () {
        return require("private-next-pages/[lang]/watches/all.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/watches/all"])
      });
    }
  